<template lang="pug">
#v-app
  v-navigation
  v-welcome
  v-features
  v-topics
  v-speakers
  v-agenda
  v-ticketing
  v-hightlight
  v-faq
  v-organizers
  v-footer
</template>

<script>
import { parse } from 'query-string'
import VNavigation from '@/components/Navigation.vue'
import VWelcome from '@/components/Welcome.vue'
import VFeatures from '@/components/Features.vue'
import VTopics from '@/components/Topics.vue'
import VSpeakers from '@/components/Speakers.vue'
import VAgenda from '@/components/Agenda.vue'
import VTicketing from '@/components/Ticketing.vue'
import VHightlight from '@/components/Highlight.vue'
import VFaq from '@/components/Faq.vue'
import VOrganizers from '@/components/Organizers.vue'
import VFooter from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    VNavigation,
    VWelcome,
    VFeatures,
    VTopics,
    VSpeakers,
    VAgenda,
    VTicketing,
    VHightlight,
    VFaq,
    VOrganizers,
    VFooter,
  },
  created() {
    $(window).resize(() => {
      const mobile = $(window).width() < 1024
      if(this.$store.state.mobile !== mobile) {
        if(mobile) {
          this.$store.commit('setMobile', true)
          this.$store.commit('setScrollOffset', 50)
        } else {
          this.$store.commit('setMobile', false)
          this.$store.commit('setScrollOffset', 70)
        }
      }
    }).resize()
    this.$store.commit('saveUtm', parse(location.search))
  },
  mounted() {
    setTimeout(() => {
      if(location.hash) {
        if($(window).scrollTop() === 0) {
          this.$scrollTo(`#v-${location.hash.substr(1)}`, 0, {
            offset: -this.$store.state.scroll.offset
          })
        }
      } else {
        history.replaceState(null, null, '#welcome')
      }
    }, 500)

    $(window).scroll(() => {
      const scrollTop = $(window).scrollTop() + this.$store.state.scroll.offset
      const sections = this.$store.state.scroll.sections
      for (let i = sections.length - 1; i >= 0; i--) {
        if(scrollTop >= $(`#v-${sections[i]}`).position().top) {
          if(this.$store.state.scroll.position !== sections[i]) {
            this.$store.commit('setScrollPosition', sections[i])
            history.replaceState(null, null, `#${sections[i]}`)
          }
          break
        }
      }
    })
  },
}
</script>

<style lang="sass" scoped>
@import "~@/mixin.sass"

#v-app
  height: 100%
  min-width: 320px
  padding-top: 70px

@media (max-width: 1023px)
  #v-app
    padding-top: 50px
</style>
